export default __webpack_public_path__ + "static/media/_dkg_nierenkrebs_rgb.1dbb8706.svg";